import { AsyncLocalStorage } from 'node:async_hooks';
import { randomUUID } from 'node:crypto';
import { createDebugLogger } from './debug.js';
const storage = new AsyncLocalStorage();
export function getCorrelationContext() {
    return storage.getStore();
}
export function getCorrelationId() {
    return storage.getStore()?.correlationId;
}
export function withCorrelation(context, fn) {
    const existing = storage.getStore();
    const merged = {
        correlationId: context.correlationId ?? existing?.correlationId ?? randomUUID(),
        runId: context.runId ?? existing?.runId,
        stepId: context.stepId ?? existing?.stepId,
        traceparent: context.traceparent ?? existing?.traceparent,
    };
    return storage.run(merged, fn);
}
/**
 * Enhanced debug logger that includes correlation context.
 */
export function createCorrelatedLogger(namespace) {
    const baseLogger = createDebugLogger(namespace);
    return (...args) => {
        const ctx = getCorrelationContext();
        if (ctx) {
            const prefix = [
                ctx.correlationId && `cid=${ctx.correlationId}`,
                ctx.runId && `run=${ctx.runId}`,
                ctx.stepId && `step=${ctx.stepId}`,
            ]
                .filter(Boolean)
                .join(' ');
            baseLogger(`[${prefix}]`, ...args);
        }
        else {
            baseLogger(...args);
        }
    };
}
//# sourceMappingURL=correlation.js.map